import { render, staticRenderFns } from "./themePc.vue?vue&type=template&id=6157524a&scoped=true"
import script from "./themePc.vue?vue&type=script&lang=js"
export * from "./themePc.vue?vue&type=script&lang=js"
import style0 from "./themePc.vue?vue&type=style&index=0&id=6157524a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157524a",
  null
  
)

export default component.exports